/**
 *
 * EmptyPage
 *
 */

import React, { memo, FunctionComponent } from 'react';
import { StyledEmptyPage } from './styledComponents';
import horseIcon from '../../assets/icons/horse-lg.png';

interface IProps {
  title: string;
}

const EmptyPage: FunctionComponent<IProps> = ({ title, children }) => {
  return (
    <StyledEmptyPage>
      <div className="d-flex w-100 flex-column align-items-center">
        <div className="txt fs-20 fw-7 txt-secondary mb-19 text-center">
          {title}
        </div>
        <div className="txt txt-secondary text-center mb-32">{children}</div>
        <img src={horseIcon} alt="" />
      </div>
    </StyledEmptyPage>
  );
};

export default memo<FunctionComponent<IProps>>(EmptyPage);
